/**
 * 24K.Infinity — Design tokens barrel.
 * Single source of truth consumed by the theme factory, the chart theme,
 * and every design-system primitive. Never hard-code a value that exists
 * here; import the token instead.
 */
import palette from './palette';
import typography from './typography';
import layout from './layout';

export * from './palette';
export * from './typography';
export * from './layout';

export { palette, typography, layout };

const tokens = { ...palette, ...typography, ...layout };
export default tokens;
